import React, { useState } from 'react';
import PropTypes from 'prop-types';
import 'components/styles/dialog.css';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { PARTNERSHIP_URL } from '../constants/index';
import { ReactComponent as HintIcon } from 'assets/images/hint-icon.svg';
import { ReactComponent as CloseIcon } from 'assets/images/black-close.svg';

const DeLinkDialog = ({ onClose, setShowDelinkSuccessMessage, employeeData }) => {
  const [delinkError, setDelinkError] = useState('');

  const cookies = new Cookies();
  const handleDelink = async () => {
    const token = cookies.get('token');

    const data = {
      employeeCode: employeeData.employeeCode,
      companyCode: employeeData.partner?.code,
      cardNumber: employeeData.cardNumber
    };

    try {
      const response = await axios.post(`${PARTNERSHIP_URL}/employees/unlink-employee`, data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response) {
        setDelinkError('');
        setShowDelinkSuccessMessage(true);
        onClose();
      }
    } catch (error) {
      setDelinkError(error.response.data.message);
      throw new Error(error);
    }
  };

  return (
    <div className="dialog-container">
      <div className="dialog-content">
        <div className="dialog-header">
          <div className="dialog-head">De-link Loyalty card number</div>
          <div className="close-button" onClick={onClose}>
            <CloseIcon/>
          </div>
        </div>
        <div className="dialog-body">
          <div className="dialog-text">
            Existing Loyalty card number linked to employee will be de-linked. Are you sure to
            proceed with this step.
          </div>
          <div className="dialog-actions">
            <div className="dialog-cancel" onClick={onClose}>
              Cancel
            </div>
            <div className="dialog-delete" onClick={handleDelink}>
              De-link
            </div>
          </div>
          {delinkError ? (
            <div className="delinkError">
              <HintIcon/>
              {delinkError}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

DeLinkDialog.propTypes = {
  onClose: PropTypes.func,
  onDelink: PropTypes.func,
  setShowDelinkSuccessMessage: PropTypes.func,
  employeeData: PropTypes.object
};

export default DeLinkDialog;
